export default __webpack_public_path__ + "static/media/support-clock-icon.cef50e5e.svg";